import React, { useState } from 'react';
import styles from './VoucherConditionItem.module.scss';
import { useNavigate } from 'react-router-dom';
import { useNotificationStore } from '@/store/NotificationStore';
import WebApp from '@twa-dev/sdk';
import { ReactComponent as TelegramPremiumIcon } from '../../../public/voucherIcons/whiteStar.svg';
import { ReactComponent as CompleteTasksIcon } from '../../../public/voucherIcons/tasksIcon.svg';
import { ReactComponent as SubscribePartnerIcon } from '../../../public/voucherIcons/subscribeIcon.svg';
import { ReactComponent as InviteFriendsIcon } from '../../../public/voucherIcons/inviteIcon.svg';
import { ReactComponent as BeReferralIcon } from '../../../public/voucherIcons/berefIcon.svg';
import { checkCondition } from '@/api/modules/Voucher/voucher';

interface VoucherCondition {
  condition_id: number;
  title: string;
  type: string;
  required_qty: number;
  user_progress: number;
  details: any;
}

interface VoucherConditionItemProps {
  condition: VoucherCondition;
  voucher_id?: number;
}

const VoucherConditionItem = ({
  condition,
  voucher_id,
}: VoucherConditionItemProps) => {
  const navigate = useNavigate();
  const current = condition.user_progress ?? 0;
  const total = condition.required_qty ?? 1;
  const percent = Math.min(100, Math.max(0, (current / total) * 100));
  const tg = window?.Telegram?.WebApp;
  const [change, setChange] = useState(false);
  const [isCompletedTask, setIsCompletedTask] = useState(false);
  const handleSubscribeTask = () => {
    if (condition.details?.link) {
      console.log(condition.details.link);
      tg?.openTelegramLink(condition.details.link);
      setChange(true);
    }
  };
  const setNotification = useNotificationStore(
    (state) => state.setNotification,
  );
  const handleCheckSubscribe = async () => {
    const response = await checkCondition(voucher_id, condition.condition_id);
    console.log(response);
    if (response.success === false) {
      setNotification({
        type: 'Error',
        message: 'Ты не подписался на канал',
      });
      setChange(false);
    } else {
      setIsCompletedTask(true);
    }
  };
  const isCompleted = current >= total;
  const showProgress = total !== 1;

  switch (condition.type) {
    case 'complete_tasks':
      return (
        <div className={styles.voucherConditionItem}>
          <div className={styles.titleIcon}>
            <CompleteTasksIcon />
          </div>
          <div className={styles.content}>
            <div className={styles.titleRow}>
              <div className={styles.title}>{condition.title}</div>
              {isCompleted ? (
                <div className={styles.done}>Выполнено ✓</div>
              ) : (
                <button
                  onClick={() => {
                    navigate(`/tasks`);
                  }}
                  className={styles.button}
                >
                  Выполнить
                </button>
              )}
            </div>
            {showProgress && (
              <div className={styles.progressWrapper}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${percent}%` }}
                  />
                </div>
                <div className={styles.progressText}>
                  {current}/{total}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    case 'subscribe_channel':
      return (
        <div className={styles.voucherConditionItem}>
          <div className={styles.titleIcon}>
            <SubscribePartnerIcon />
          </div>
          <div className={styles.content}>
            <div className={styles.titleRow}>
              <div className={styles.title}>{condition.title}</div>
              {isCompleted || isCompletedTask ? (
                <div className={styles.done}>Выполнено ✓</div>
              ) : change ? (
                <button
                  onClick={handleCheckSubscribe}
                  className={styles.button}
                >
                  Проверить
                </button>
              ) : (
                <button onClick={handleSubscribeTask} className={styles.button}>
                  Выполнить
                </button>
              )}
            </div>
            {showProgress && (
              <div className={styles.progressWrapper}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${percent}%` }}
                  />
                </div>
                <div className={styles.progressText}>
                  {current}/{total}
                </div>
              </div>
            )}
          </div>
        </div>
      );
    case 'subscribe_partner':
      return (
        <div className={styles.voucherConditionItem}>
          <div className={styles.titleIcon}>
            <SubscribePartnerIcon />
          </div>
          <div className={styles.content}>
            <div className={styles.titleRow}>
              <div className={styles.title}>{condition.title}</div>
              {isCompleted || isCompletedTask ? (
                <div className={styles.done}>Выполнено ✓</div>
              ) : change ? (
                <button
                  onClick={handleCheckSubscribe}
                  className={styles.button}
                >
                  Проверить
                </button>
              ) : (
                <button onClick={handleSubscribeTask} className={styles.button}>
                  Выполнить
                </button>
              )}
            </div>
            {showProgress && (
              <div className={styles.progressWrapper}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${percent}%` }}
                  />
                </div>
                <div className={styles.progressText}>
                  {current}/{total}
                </div>
              </div>
            )}
          </div>
        </div>
      );

    case 'invite_friends':
      return (
        <div className={styles.voucherConditionItem}>
          <div className={styles.titleIcon}>
            <InviteFriendsIcon />
          </div>
          <div className={styles.content}>
            <div className={styles.titleRow}>
              <div className={styles.title}>{condition.title}</div>
              {isCompleted ? (
                <div className={styles.done}>Выполнено ✓</div>
              ) : (
                <button
                  onClick={() => {
                    navigate(`/friends`);
                  }}
                  className={styles.button}
                >
                  Выполнить
                </button>
              )}
            </div>
            {showProgress && (
              <div className={styles.progressWrapper}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${percent}%` }}
                  />
                </div>
                <div className={styles.progressText}>
                  {current}/{total}
                </div>
              </div>
            )}
          </div>
        </div>
      );

    default:
      return (
        <div className={styles.voucherConditionItem}>
          <div className={styles.titleIcon}></div>
          <div className={styles.content}>
            <div className={styles.titleRow}>
              <div className={styles.title}>{condition.title}</div>
              {isCompleted ? (
                <div className={styles.done}>Выполнено ✓</div>
              ) : (
                <button
                  onClick={() => {
                    navigate(`/tasks`);
                  }}
                  className={styles.button}
                >
                  Выполнить
                </button>
              )}
            </div>
            {showProgress && (
              <div className={styles.progressWrapper}>
                <div className={styles.progressBar}>
                  <div
                    className={styles.progressFill}
                    style={{ width: `${percent}%` }}
                  />
                </div>
                <div className={styles.progressText}>
                  {current}/{total}
                </div>
              </div>
            )}
          </div>
        </div>
      );
  }
};

export default VoucherConditionItem;
